import React, { useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { SHOP } from "../shop";

export const ORDER_THANK_YOU_DEFAULTS = {
  headline: "Vielen Dank für deine Rückmeldung!",
  subtext:
    "Wir haben deine Antwort erhalten und melden uns bei dir, " +
    "falls es Rückfragen gibt.",
  nextStepsTitle: "Wie geht es weiter?",
  nextStepsBullets: [
    "Wir prüfen deine Rückmeldung und starten mit der Produktion.",
    "Bei Änderungswünschen melden wir uns kurzfristig bei dir.",
    "Du erhältst eine Bestätigungs-E-Mail von uns.",
    "Fragen? Antworte einfach auf die E-Mail, die du von uns erhalten hast.",
  ],
  // Nur der Rueckfall, wenn config/orderThankYouPage kein footerNote traegt.
  // Shop-neutral, weil dieselbe Seite fuer mehrere Shops gebaut wird.
  footerNote: `Vielen Dank — Dein Team von ${
    SHOP.name}`,
};

const OrderThankYouPage = ({ textConfig = null }) => {
  const [texts, setTexts] = useState(ORDER_THANK_YOU_DEFAULTS);

  useEffect(() => {
    if (textConfig) {
      setTexts({ ...ORDER_THANK_YOU_DEFAULTS, ...textConfig });
      return;
    }
    const load = async () => {
      const snap = await getDoc(doc(db, "config", "orderThankYouPage"));
      if (snap.exists()) {
        setTexts({ ...ORDER_THANK_YOU_DEFAULTS, ...snap.data() });
      }
    };
    load();
  }, [textConfig]);

  return (
    <div style={{
      maxWidth: 560, margin: "4em auto", padding: "0 1em", textAlign: "center",
    }}>
      <div style={{
        background: "#fff", borderRadius: "10px",
        boxShadow: "0 1px 6px rgba(0,0,0,0.08)", padding: "2.5em 2em",
      }}>
        <img src={SHOP.logo} alt={SHOP.name}
          style={{ height: 84, display: "block", margin: "0 auto 0.75em" }} />
        <h2 style={{ margin: "0 0 0.5em", color: SHOP.primary, fontSize: "1.4rem" }}>
          {texts.headline}
        </h2>
        <p style={{ color: "#4a5568", marginBottom: "1.5em", lineHeight: "1.6" }}>
          {texts.subtext}
        </p>

        <div style={{
          background: SHOP.pageBg, borderRadius: "8px",
          padding: "1.25em 1.5em", textAlign: "left",
        }}>
          <p style={{
            margin: "0 0 0.5em", fontWeight: "700",
            color: "#2d3748", fontSize: "0.9rem",
          }}>
            {texts.nextStepsTitle}
          </p>
          <ul style={{
            margin: 0, paddingLeft: "1.25em",
            color: "#718096", fontSize: "0.875rem", lineHeight: "1.8",
          }}>
            {(texts.nextStepsBullets || []).map((b, i) => (
              <li key={i}>{b}</li>
            ))}
          </ul>
        </div>

        <p style={{ marginTop: "1.5em", color: "#a0aec0", fontSize: "0.85rem" }}>
          {texts.footerNote}
        </p>
      </div>
    </div>
  );
};

export default OrderThankYouPage;
